/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  fetchSelectedUserDetail,
  fetchHackerActivity,
  fetchHackerTrainingPlans,
  getHackerCodeSubmissions,
  cleanUserDetailModal,
} from 'app/state/modules/users'
import {
  updateTeamPrivileges,
  setSelectedUser,
  removeHackerFromTeam
} from 'app/state/modules/team'
import {
  updateHackerRole,
  addLicense,
  removeLicense,
} from 'app/state/modules/hacker'
import GenericModal from 'app/views/components/Modals/GenericModal'
import getLocalDateFromUTC from 'app/views/utils/getLocalDateFromUTC'
import Statistics from '../Statistics'
import FormatedMinutes from '../FormatedMinutes'
import Tabs from '../Tabs'
import TeamTab from './TeamTab'
import SettingsTab from './SettingsTab'
import ActivityTab from './ActivityTab'
import TrainingTab from './TrainingTab'
import MasteryTab from './MasteryTab'
import ChallengesTab from './ChallengesTab'
import GenerateCertificate from '../GenerateCertificate'

class UserDetailModal extends React.Component {
  constructor(props) {
    super(props)
    this.refreshUserDetail = this.refreshUserDetail.bind(this)
    this.handleClickAddLicenseToUser = this.handleClickAddLicenseToUser.bind(this)
    this.handleClickRemoveLicenseFromUser = this.handleClickRemoveLicenseFromUser.bind(this)
    this.getInitialTab = this.getInitialTab.bind(this)
    this.onPrevious = this.onPrevious.bind(this)
    this.handleClickRemove = this.handleClickRemove.bind(this)
    this.onNext = this.onNext.bind(this)
    this.onKeyUp = this.onKeyUp.bind(this)
    if (this.props.onRef) this.props.onRef(this)
  }

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyUp)
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.selectedUserDetail === 'loading' && this.props.selectedUserDetail !== 'loading')
    ) {
      if (this.props.onShow) this.props.onShow()
      this.modal.show()
    } else if (
      prevProps.selectedUserDetail !== 'loading' && this.props.selectedUserDetail === 'loading'
    ) {
      this.modal.hide()
    }
    if (prevProps.match.params.tab !== this.props.match.params.tab) {
      if (this.tabsComponent) {
        this.tabsComponent.onChangeTab(this.getInitialTab())
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyUp)
  }

  onPrevious(e = null) {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }

    let prevHacker = null
    if (this.props.localData) {
      if (this.props.localData[this.props.selectedUserDetail.localIndex]) {
        prevHacker = this.props.localData[this.props.selectedUserDetail.localIndex].prev_hacker
      }
    } else {
      prevHacker = this.props.selectedUserDetail.prev_hacker
    }
    if (prevHacker) {
      if (this.trainingTab) {
        this.trainingTab.resetCodeSubmissionShow()
      }
      this.props.fetchSelectedUserDetail(
        this.props.match.params.organization_uuid,
        {
          uuid: prevHacker,
          justTeam: this.props.match.params.team_uuid || null,
        },
        true,
        {
          localIndex: this.props.selectedUserDetail.localIndex - 1,
        },
      )
      this.props.fetchHackerActivity(
        this.props.match.params.organization_uuid,
        prevHacker,
        'main',
      )
      this.props.fetchHackerTrainingPlans(
        this.props.match.params.organization_uuid,
        prevHacker,
      )
    }
  }

  onNext(e = null) {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    let nextHacker = null
    if (this.props.localData) {
      if (this.props.localData[this.props.selectedUserDetail.localIndex]) {
        nextHacker = this.props.localData[this.props.selectedUserDetail.localIndex].next_hacker
      }
    } else {
      nextHacker = this.props.selectedUserDetail.next_hacker
    }
    if (nextHacker) {
      if (this.trainingTab) {
        this.trainingTab.resetCodeSubmissionShow()
      }
      this.props.fetchSelectedUserDetail(
        this.props.match.params.organization_uuid,
        {
          uuid: nextHacker,
          justTeam: this.props.match.params.team_uuid || null,
        },
        true,
        {
          localIndex: this.props.selectedUserDetail.localIndex + 1,
        },
      )
      this.props.fetchHackerActivity(
        this.props.match.params.organization_uuid,
        nextHacker,
        'main',
      )
      this.props.fetchHackerTrainingPlans(
        this.props.match.params.organization_uuid,
        nextHacker,
      )
    }
  }

  onKeyUp(e) {
    if (e.keyCode === 37) {
      this.onPrevious()
    }
    if (e.keyCode === 39) {
      this.onNext()
    }
  }

  getInitialTab() {
    switch (this.props.match.params.tab) {
      case 'training':
        return 1
      case 'challenges':
        return 2
      case 'teams':
        return 3
      case 'activity':
        return 4
      case 'settings':
        return 5
      default:
        return 0
    }
  }

  handleClickAddLicenseToUser(hackerId, licenseTypeUUID) {
    this.props.addLicense(this.props.match.params.organization_uuid, hackerId, licenseTypeUUID)
      .then(() => {
        this.refreshUserDetail()
      })
  }

  handleClickRemoveLicenseFromUser(hackerId, licenseTypename, licenseTypeUUID) {
    this.props.removeLicense(this.props.match.params.organization_uuid, hackerId, licenseTypename, licenseTypeUUID)
      .then(() => {
        this.refreshUserDetail()
      })
  }

  handleClickRemove(teamUUID, hackerUUID) {
    if (this.props.match.params.team_uuid === teamUUID) {
      this.modal.hide()
      this.props.cleanUserDetailModal()
      if (this.props.onHide) {
        this.props.onHide()
      }
      if (this.props.onRefresh) {
        this.props.onRefresh()
      }
    }
    this.props.removeHackerFromTeam(this.props.match.params.organization_uuid, teamUUID, hackerUUID)
      .then(() => {
        this.refreshUserDetail()
      })
  }

  refreshUserDetail() {
    this.props.fetchSelectedUserDetail(this.props.match.params.organization_uuid, this.props.selectedUserDetail, true)
    if (this.props.onRefresh) {
      this.props.onRefresh()
    }
  }

  render() {
    const { selectedUserDetail } = this.props
    return (
      <>
        <GenericModal
          noButtons
          handleOnClickOverlay={() => {
            this.modal.hide()
            this.props.cleanUserDetailModal()
            if (this.props.onHide) {
              this.props.onHide()
            }
          }}
          overlayElements={!this.props.dontShowArrows && (
            <>
              {
                ((!this.props.localData && this.props.selectedUserDetail.prev_hacker) || (this.props.localData && this.props.selectedUserDetail.localIndex > 0)) && (
                  <i
                    onClick={this.onPrevious}
                    data-uk-icon="icon: arrow-left; ratio: 3"
                    style={{
                      position: 'absolute',
                      left: (window.innerWidth / 5) / 3,
                      color: '#fff',
                      zIndex: 100000,
                      top: (window.innerHeight / 2.2),
                      cursor: 'pointer',
                    }}
                  />
                )
              }
              {
                ((!this.props.localData && this.props.selectedUserDetail.next_hacker) || (this.props.localData && this.props.selectedUserDetail.localIndex < (this.props.localData.length - 1))) && (
                  <i
                    onClick={this.onNext}
                    data-uk-icon="icon: arrow-right; ratio: 3"
                    style={{
                      position: 'absolute',
                      right: (window.innerWidth / 5) / 3,
                      color: '#fff',
                      zIndex: 100000,
                      top: (window.innerHeight / 2.2),
                      cursor: 'pointer',
                    }}
                  />
                )
              }
            </>
          )}
          canClose
          id="user-detail-modal"
          modalContainer
          width="uk-width-3-5"
          ref={(ref) => { this.modal = ref }}
          body={selectedUserDetail !== 'loading' && (
            <div
              className="uk-padding"
              style={{
                paddingTop: 0,
              }}
            >
              <h2

                style={{
                  marginTop: 0,
                  marginBottom: 0,
                }}
              >
                {selectedUserDetail.email}
                <GenerateCertificate
                  disabled={!selectedUserDetail.has_finished_training}
                  email={selectedUserDetail.email}
                  completionDate={selectedUserDetail.last_completed_at}
                  courseName="OWASP Top 10"
                  className="uk-button uk-button-default uk-text-capitalize uk-button-small uk-align-right"
                >
                  {selectedUserDetail.has_finished_training ? (
                    <>
                      <span data-uk-icon="download" style={{ paddingRight: 10 }} />
                      Download Certificate
                    </>
                  ) : 'OWASP Top 10 Not Complete'}

                </GenerateCertificate>
              </h2>
              <span className="uk-margin-remove uk-text-muted uk-text-italic">
                {selectedUserDetail.last_seen ? (
                  `Last seen ${getLocalDateFromUTC(selectedUserDetail.last_seen).fromNow()}`
                )
                  : (
                    'Never logged in'
                  )}
              </span>
              <div
                className="uk-margin-top uk-margin-bottom"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Statistics
                  header={(
                    <span
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginLeft: 10,
                        fontSize: 38,
                      }}
                    >
                      {`${(((selectedUserDetail.completed_assigned / selectedUserDetail.total_assigned) * 100) || 0).toFixed(0)}`}
                      <span style={{ fontSize: 22 }}>%</span>
                    </span>
                  )}
                  content=""
                  detail="Assigned Lessons Completed"
                />
                <Statistics
                  header={(
                    <FormatedMinutes
                      minutes={selectedUserDetail.total_time}
                    />
                  )}
                  content=""
                  detail="Total Training Time"
                />
                <Statistics
                  header={selectedUserDetail.code_submission}
                  content=""
                  detail="Code Submissions"
                />
              </div>
              <Tabs
                id="_user-modal-tabs"
                activeTab
                initialTab={this.getInitialTab()}
                ref={(ref) => { this.tabsComponent = ref }}
                tabs={[{
                  key: 'mastery',
                  title: 'Mastery',
                  onChangeTab: () => { if (this.props.match.params.tab && this.props.match.params.tab !== 'mastery') this.props.history.push(`${this.props.match.url.substr(0, this.props.match.url.lastIndexOf('/'))}/mastery`) },
                  component: (
                    <MasteryTab
                      selectedUser={this.props.selectedUserDetail}
                    />
                  ),
                }, {
                  key: 'training',
                  title: 'Training',
                  onChangeTab: () => {
                    if (this.props.match.params.tab && this.props.match.params.tab !== 'training') this.props.history.push(`${this.props.match.url.substr(0, this.props.match.url.lastIndexOf('/'))}/training`)
                    this.props.fetchHackerTrainingPlans(
                      this.props.organization.uuid,
                      this.props.selectedUserDetail.uuid,
                    )
                  },
                  component: (
                    <TrainingTab
                      ref={(ref) => { this.trainingTab = ref }}
                      getHackerCodeSubmissions={this.props.getHackerCodeSubmissions}
                      match={this.props.match}
                      organization={this.props.organization}
                      plans={this.props.plans}
                      selectedUser={this.props.selectedUserDetail}
                    />
                  ),
                }, {
                  key: 'challenges',
                  title: 'Challenges',
                  onChangeTab: () => {
                    if (this.props.match.params.tab && this.props.match.params.tab !== 'challenges') this.props.history.push(`${this.props.match.url.substr(0, this.props.match.url.lastIndexOf('/'))}/challenges`)
                  },
                  component: (
                    <ChallengesTab
                      challenges={this.props.selectedUserDetail.challenges}
                    />
                  ),
                }, {
                  key: 'teams',
                  title: 'Teams',
                  onChangeTab: () => { if (this.props.match.params.tab && this.props.match.params.tab !== 'teams ') this.props.history.push(`${this.props.match.url.substr(0, this.props.match.url.lastIndexOf('/'))}/teams`) },
                  component: (
                    <TeamTab
                      onRemoveFromTeam={this.handleClickRemove}
                      cleanUserDetailModal={this.props.cleanUserDetailModal}
                      setSelectedUser={this.props.setSelectedUser}
                      onEditTeams={this.props.onEditTeams}
                      hackerUUID={this.props.hackerUUID}
                      organization={this.props.organization}
                      updateTeamPrivileges={this.props.updateTeamPrivileges}
                      selectedUser={this.props.selectedUserDetail}
                      refreshUserDetail={this.refreshUserDetail}
                      match={this.props.match}
                    />
                  ),
                }, {
                  key: 'acitivity',
                  title: 'Activity',
                  onChangeTab: () => {
                    if (this.props.match.params.tab && this.props.match.params.tab !== 'activity') this.props.history.push(`${this.props.match.url.substr(0, this.props.match.url.lastIndexOf('/'))}/activity`)
                    this.props.fetchHackerActivity(
                      this.props.match.params.organization_uuid,
                      this.props.selectedUserDetail.uuid,
                      'main',
                    )
                  },
                  component: (
                    <ActivityTab
                      selectedUser={this.props.selectedUserDetail}
                      fetchHackerActivity={this.props.fetchHackerActivity}
                      activity={this.props.activity}
                      organization={this.props.organization}
                    />
                  ),
                }, {
                  key: 'settings',
                  title: 'Settings',
                  onChangeTab: () => { if (this.props.match.params.tab && this.props.match.params.tab !== 'settings') this.props.history.push(`${this.props.match.url.substr(0, this.props.match.url.lastIndexOf('/'))}/settings`) },
                  component: (
                    <SettingsTab
                      onRemoveFromOrg={this.props.onRemoveFromOrg}
                      organization={this.props.organization}
                      hackerUUID={this.props.hackerUUID}
                      selectedUser={this.props.selectedUserDetail}
                      match={this.props.match}
                      refreshUserDetail={this.refreshUserDetail}
                      getHackers={this.props.getHackers}
                      updateHackerRole={this.props.updateHackerRole}
                      availableLicenses={this.props.availableLicenses}
                      availableLicenseTypes={this.props.availableLicenseTypes}
                      handleClickRemoveLicenseFromUser={this.handleClickRemoveLicenseFromUser}
                      handleClickAddLicenseToUser={this.handleClickAddLicenseToUser}

                    />
                  ),
                }]}
              />
            </div>
          )}
        />
      </>
    )
  }
}

const mapStateToProps = (state, props) => ({
  selectedUserDetail: state.users.selectedUserDetail,
  hackerUUID: state.hacker.profile.user_id,
  availableLicenses: state.hacker.currentTeamDetails.available_licenses,
  availableLicenseTypes: state.hacker.currentTeamDetails.available_license_types,
  organization: state.hacker.organizationsHash[props.match.params.organization_uuid],
  activity: state.users.activity,
  plans: state.users.plans,
})

export default withRouter(connect(mapStateToProps, {
  fetchSelectedUserDetail,
  updateTeamPrivileges,
  updateHackerRole,
  fetchHackerTrainingPlans,
  addLicense,
  removeLicense,
  fetchHackerActivity,
  getHackerCodeSubmissions,
  setSelectedUser,
  cleanUserDetailModal,
  removeHackerFromTeam,
})(UserDetailModal))
